import { commonSanitizeOptions } from "layouts/QuestionManager/QuestionManager.constants";

export const emailPreviewSanitizeOptions = {
  ...commonSanitizeOptions,
  allowedAttributes: {
    ...commonSanitizeOptions.allowedAttributes,
    span: ["name", "data-question-id"],
  },
};
